import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import axios from "axios";
import { openDB } from "idb";
import moment from "moment";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: "AIRWAYS3Mobile",
  storage: window.sessionStorage,
});

export default new Vuex.Store({
  state: {
    crfTitle: "",
    menuItems: [],
    customErrors: [],
    showAppBusyAnimation: false,
    mainMenuDrawer: null,
  },
  mutations: {
    setCrfTitle(state, title) {
      state.crfTitle = title;
    },
    setAppBusyAnimation(state, status) {
      state.showAppBusyAnimation = status;
    },
    setMainMenuDrawer(state, status) {
      state.mainMenuDrawer = status;
    },
    showMenuItems(state, menuItemIds, status) {
      let mItem;
      menuItemIds.forEach((id) => {
        mItem = state.menuItems.find((m) => m.id == id);
        if (mItem) {
          mItem.showMenuItem = status;
        }
      });
    },
    setRandomisationMenuItem(state) {
      state.menuItems = Object.assign(
        [],
        [
          {
            to: "/",
            caption: "Randomise Participant",
            iconPath: "mdi-file-document-edit-outline",
            formCompleteness: "",
            showBadge: false,
            showMenuItem: true,
            id: "tbRandomisation",
          },
          {
            to: "/rand-outcome",
            caption: "View Rand Outcome",
            iconPath: "mdi-file-document-edit-outline",
            formCompleteness: "",
            showBadge: false,
            showMenuItem: true,
          },
          {
            to: "/post-rand",
            caption: "Post Rand CRF",
            iconPath: "mdi-file-document-edit-outline",
            formCompleteness: "",
            showBadge: false,
            showMenuItem: true,
          },
          {
            to: "/sync-data",
            caption: "Sync Data",
            iconPath: "mdi-cloud-sync",
            formCompleteness: "",
            showBadge: false,
            showMenuItem: true,
          },
          {
            to: "/settings",
            caption: "Settings",
            iconPath: "mdi-account-cog-outline",
            formCompleteness: "",
            showBadge: false,
            showMenuItem: true,
          },
          /*  {
            to: "/activate-profile",
            caption: "Activate Profile",
            iconPath: "mdi-account-cog-outline",
            formCompleteness: "",
            showBadge: false,
            showMenuItem: true,
          }, */
        ]
      );
    },
  },
  getters: {
    getAppBusyAnimation(state) {
      return state.showAppBusyAnimation;
    },
    getMainMenuDrawer(state) {
      return state.mainMenuDrawer;
    },
    getCrfTitle(state) {
      return state.crfTitle;
    },
    getMenuItems(state) {
      return state.menuItems;
    },
  },
  actions: {
    async clientIsOffline() {
      //debugger;
      try {
        const actionUrl = `${process.env.BASE_URL}AppAuth/VerifyClientOfflineStatus`;
        const { data } = await axios.get(actionUrl);
        if (data == 0) {
          return false;
        } else {
          return true;
        }
      } catch {
        return true;
      }
    },
    async fetchAppUserId() {
      const db = await openDB("AIRWAYS3idb");
      return (
        (await db
          .transaction("tbSettings")
          .objectStore("tbSettings")
          .get("pin")) || null
      );
    },
    async fetchSites() {
      const db = await openDB("AIRWAYS3idb");
      return (
        (await db
          .transaction("tbSettings")
          .objectStore("tbSettings")
          .get("sites")) || []
      );
    },
    async fetchDefaultSiteOrgCode() {
      const db = await openDB("AIRWAYS3idb");
      return (
        (await db
          .transaction("tbSettings")
          .objectStore("tbSettings")
          .get("defaultSite")) || null
      );
    },
    async fetchLatestRandResult() {
      const db = await openDB("AIRWAYS3idb");
      return (
        (await db
          .transaction("tbSettings")
          .objectStore("tbSettings")
          .get("latestRandResult")) || {}
      );
    },
    async fetchRandomisationCount() {
      //debugger;
      const db = await openDB("AIRWAYS3idb");
      return (
        (await db
          .transaction("tbRandomisation")
          .objectStore("tbRandomisation")
          .count()) || 0
      );
    },
    async fetchCompletedPostRandCRFCount() {
      const db = await openDB("AIRWAYS3idb");
      const postRandCRFs = (
        await db
          .transaction("tbPostRandCRF")
          .objectStore("tbPostRandCRF")
          .getAll()
      ).filter((p) => p && p.prd_DidPatientSurvivedTheCardiacArrest);
      return postRandCRFs.length;
    },
    async fetchUncompletedPostRandCRFCount() {
      const db = await openDB("AIRWAYS3idb");
      const postRandCRFs = await db
        .transaction("tbPostRandCRF")
        .objectStore("tbPostRandCRF")
        .getAll();
      if (postRandCRFs.length == 0) return 0;
      const unCompletedPostRandCRFs = postRandCRFs.filter(
        (p) => p == null || !p.prd_DidPatientSurvivedTheCardiacArrest
      );
      return unCompletedPostRandCRFs.length;
    },
    async fetchAllOfflineRandomisations() {
      //debugger;
      const db = await openDB("AIRWAYS3idb");
      return (
        (await db
          .transaction("tbRandomisation")
          .objectStore("tbRandomisation")
          .getAll()) || null
      );
    },
    async clearAllOfflineRandomisations() {
      //debugger;
      const db = await openDB("AIRWAYS3idb");
      await db
        .transaction("tbRandomisation", "readwrite")
        .objectStore("tbRandomisation")
        .clear();
    },
    async saveOfflineRandomisation(sdata) {
      //debugger;
      const db = await openDB("AIRWAYS3idb");
      await db
        .transaction("tbRandomisation", "readwrite")
        .objectStore("tbRandomisation")
        .add(sdata);
    },
    async noSyncInProgress() {
      let status = false;
      const db = await openDB("AIRWAYS3idb");
      const tx = db.transaction("tbSettings", "readwrite");
      const store = tx.objectStore("tbSettings");
      const { state, lastSyncDate } = await store.get("syncSatus");
      if (state == 0 || moment().diff(moment(lastSyncDate), "minutes") >= 2) {
        await store.put(
          { state: 1, lastSyncDate: moment().format() },
          "syncSatus"
        );
        status = true;
      }
      await tx.done;
      return status;
    },
  },
  plugins: [vuexLocalStorage.plugin],
});
